import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

import {
  BOOKING_FORM_STATUS,
  ERROR_MESSAGE,
} from "../../config/constant";
import { useParams, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  getApplicantDetails,
  getMasterDataList,
  getOppprtunityDetails,
  setApplicantTotal,
  setOffline,
  setResetData,
} from "../customer-form/customer-form.slice";
import Header from "../../layout/header/Header";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import checkThank from "../../../src/assets/icons/check-thank.svg";

import ReferrerDetails from "./components/ReferrerDetails";
import Footer from "../../layout/footer/Footer";
const ReferralForm = () => {
  const dispatch = useDispatch();
  const { applicantActiveStep ,applicantData} = useSelector((state) => state.customerForm);
  const { oppId } = useParams();
  const history = useHistory();
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
      const [formSubmitted, setFormSubmitted] = useState(false);
      const {  offline } = useSelector((state) => state.customerForm);
    
    useEffect(() => {
      
      if (
        applicantData?.referrerDetails?.isSignedOffline === true ||
        applicantData?.referrerDetails?.signedStatus === BOOKING_FORM_STATUS?.SIGNED ||
        applicantData?.referrerDetails?.signedStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE 
      ) {
        setFormSubmitted(true);
      } else {
        setFormSubmitted(false);
      }
    }, [applicantData]);
      useEffect(() => {
        if (applicantData?.referrerDetails?.isSignedOffline === true) {
          dispatch(setOffline(true));
        } else {
          dispatch(setOffline(false));
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [applicantData?.referrerDetails?.isSignedOffline]);
      
    useEffect(() => {
    if (oppId?.length > 0) {
      dispatch(getOppprtunityDetails(`/${oppId}`)).unwrap();
      dispatch(getMasterDataList());
      dispatch(getApplicantDetails(`/${oppId}`))
        .unwrap()
        .then((res) => {
          if (res?.signedPdf === null) {
            if (res?.leegalityData?.isSignLater === true) {
              history.push(`/referral-form/${oppId}`);
            } else {
              dispatch(setApplicantTotal(res?.noOfApplicants));
            }
          }
      
        })
        .catch((error) => {
          setFormSubmitted(false);
          dispatch(setResetData());
          history.push(`/404`);
          if (!error?.errors?.message?.includes("Booking with Opportunity")) {
            setSnackBarconfig({
              open: true,
              message: ERROR_MESSAGE,
              severity: "error",
            });
          }
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [applicantActiveStep]);

  return (
    <>
      <Helmet>
        <title>Referral Form</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <>
        <Header />
        <Stack>
          <Grid
            container
            spacing={0}
            sx={{
              p: 0,
              paddingLeft: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "7%",
              },
              paddingRight: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "7%",
              },
              mb: {
                xs: 2,
                sm: 4,
                md: 5, // Desktop
              },
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                textAlign: {
                  xs: "center",
                  sm: "center",
                  md: "center",
                },
                pt: {
                  xs: "16px",
                  sm: "30px",
                  md: "36px",
                },
                pb: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                },
              }}
            >
              <Typography
                sx={{
                  color: "#1A407D",
                  fontSize: {
                    xs: "20px",
                    sm: "20px",
                    md: "24px",
                  },
                  fontWeight: "700",
                  lineHeight: {
                    xs: "28px",
                    sm: "32px",
                    md: "36px",
                  },
                  mb: {
                    xs: 0.5,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                Referral Form
              </Typography>
              {(!formSubmitted ) && <Typography
                sx={{
                  color: "#1C252E",
                  fontSize: {
                    md: "14px",
                  },
                  fontWeight: "700",
                  lineHeight: {
                    md: "22px",
                  },
                  mb: {
                    md: "16px",
                  },
                }}
              >
                Enter the details to get going
              </Typography>}
              {(formSubmitted && !offline) && (
            <Box>
              <div className="checkThank">
                <img src={checkThank} alt="" />
              </div>
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#1C252E",
                  mb: 1,
                  textAlign: "center",
                }}
              >
                Thank you! You have submitted the Referral Form.
              </Typography>
            </Box>
          )}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box>
                <ReferrerDetails handleActiveStep={true}></ReferrerDetails>
              </Box>
            </Grid>
          </Grid>
        </Stack>
        <Footer />
      </>

      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default ReferralForm;
